module.exports = __webpack_public_path__ + "kibervarnost/media/naredi-backup.2598fa64.webm";